import * as React from "react";

const Copy: React.FC = () => {
    return <svg width="18px" height="24px" viewBox="0 0 18 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-143.000000, -233.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(64.000000, 3.000000)">
                    <path d="M13,0 L0,0 L0,20 L4,20 L4,24 L18,24 L18,4 L13,4 L13,0 Z M4,18 L2,18 L2,2 L11,2 L11,4 L4,4 L4,18 L4,18 Z M16,22 L6,22 L6,6 L16,6 L16,22 L16,22 Z"></path>
                    <rect x="8" y="9" width="6" height="2"></rect>
                    <rect x="8" y="12" width="6" height="2"></rect>
                    <rect x="8" y="15" width="4" height="2"></rect>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Copy);
